import { useCallback, useState } from 'react';

import { snapPoint } from '@/api/endpoints/snap';
import type { SnapResponse } from '@/types/snap';

interface UseSnapPointValue {
  readonly loading: boolean;
  readonly snap: (lat: number, lon: number) => Promise<SnapResponse | null>;
}

export function useSnapPoint(): UseSnapPointValue {
  const [loading, setLoading] = useState(false);

  const snap = useCallback(async (lat: number, lon: number) => {
    setLoading(true);
    try {
      return await snapPoint({ lat, lon });
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, snap };
}
